import { createAction } from '@reduxjs/toolkit'

interface ScalesReading {
  createdAt: number
  value: number
}

export const scalesReadingReceived = createAction<ScalesReading>(
  'scalesReading/scalesReadingReceived',
)
